import React from 'react'

import openPortraitImg from '../../../../../images/puzzles/library/openPortrait.png'

function TheOpenPortrait({text=false}) {
    const style = {
        filter: 'sepia(.25)'
    }
    
    return (
        <div className="puzzleContainer">
            <img
                className="puzzlePopUp_img"
                src={openPortraitImg}
                alt='three symbols'
                style={style}
            />
            <p className="puzzlePopUp_text">{text ? text : 'What could these mean?'}</p>   
        </div>
    )
}

export default TheOpenPortrait